export default import.meta.ROLLDOWN_FILE_URL_Ru$ywL4glQBqWhWoJo7rJg